var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectorRemote',{attrs:{"options":_vm.options,"popper-class":"dv-select-pop","datasource-list":_vm.datasourceList,"placeholder":"请选择数据源","remote-method":_vm.handleRemoteMethod},on:{"change":_vm.handleChange},model:{value:(_vm.inputData),callback:function ($$v) {_vm.inputData=$$v},expression:"inputData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }